module.exports = __webpack_public_path__ + "img/41_69_004_860.8429e2d4.jpg";